// src/components/AuthForm.jsx
import React, { useState } from 'react';
import axiosInstance from '../api/axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const AuthForm = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Basic validation
    if (!formData.email || !formData.password) {
      setError('Please fill in all fields');
      return;
    }

    if (!isLogin && formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const endpoint = isLogin ? '/users/login' : '/users/register';
      const payload = {
        user: {
          email: formData.email,
          password: formData.password,
        }
      };
      console.log('Sending payload:', payload);
      const response = await axiosInstance.post(endpoint, payload);

      const data = await response.data;
      if (data.status === 'success') {
        console.log('Login response:', data);
        // Create a proper user object from the response
        const userData = {
            ...data.user,
            role: data.user.role || 'event-user' // ensure role is set
          };

        // Call login with the token and user data
        login(data.token, userData);

        // Debug log the stored user data
        console.log('Stored user data:', userData);
        // Store token in localStorage
        //localStorage.setItem('token', data.token);
        
        // Store user data if needed
        //localStorage.setItem('user', JSON.stringify(data.user));
        // Redirect to chat page
        // Navigate based on user role
        if (userData.role === 'admin') {
            //navigate('/venue');
            navigate('/chat');
          } else {
            navigate('/chat');
          }
        //navigate('/chat');
     } else {
        // Handle error
        console.error('Login failed:', data.message);
      }

    //   if (!response.ok) {
    //     throw new Error('Authentication failed');
    //   }

    //   if (response.headers['access-token']) {
    //     localStorage.setItem('access-token', response.headers['access-token']);
    //     localStorage.setItem('client', response.headers['client']);
    //     localStorage.setItem('uid', response.headers['uid']);
    //   }

    //   const data = await response.json();
      // Handle successful authentication (e.g., store token, redirect)
      console.log('Success:', data);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-center mb-6">
          {isLogin ? 'Login' : 'Sign Up'}
        </h2>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          <div>
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          {!isLogin && (
            <div>
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}
          
          {error && (
            <div className="p-3 text-sm text-red-500 bg-red-100 rounded-md">
              {error}
            </div>
          )}
          
          <button
            type="submit"
            className="w-full py-2 px-4 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {isLogin ? 'Login' : 'Sign Up'}
          </button>
        </form>
        
        <div className="mt-4 text-center">
          <button
            onClick={() => setIsLogin(!isLogin)}
            className="text-sm text-blue-500 hover:text-blue-600"
          >
            {isLogin
              ? "Don't have an account? Sign Up"
              : 'Already have an account? Login'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthForm;